import React from "react";
import { useTranslation } from "react-i18next";
import { Owner } from "../../../types/modules/admin/Owner";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";
import { Customer } from "../../../types/modules/admin/customer.type";
import CustomerItem from "./CustomerItem";

interface Props {
  customers: Customer[];
}

const CustomersListTable: React.FC<Props> = ({ customers }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("name")}</th>
            <th className="p-3 font-normal capitalize">{t("phone")}</th>
            <th className="p-3 font-normal capitalize">{t("email")}</th>
            <th className="p-3 font-normal capitalize">{t("account_status")}</th>
            <th className="p-3 font-normal capitalize">{t("registration_date")}</th>
            <th className="p-3 font-normal capitalize">{t("last_login")}</th>
            <th className="p-3 font-normal capitalize">{t("lastActive")}</th>
            <th className="p-3 font-normal capitalize">{t("profile")}</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {customers.map((customer, index) => (
            <tr
              key={customer.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
            <CustomerItem key={customer.id} customer={customer}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default CustomersListTable;